import Nullstack from 'nullstack';
export default function IconCe({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ce",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 4a8 8 0 1 0 0 16"
  }), "   ", Nullstack.element("path", {
    d: "M20 4a8 8 0 1 0 0 16"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "20",
    y2: "12"
  }), " ");
}